module.exports = __webpack_public_path__ + "static/media/panel_contraseña.db1dc915.svg";